import {useSelector} from "react-redux";

export const CSSRenderer = () => {
    const make = useSelector(state => state.appParamsReducer.brand);
    switch (make) {
        case 'buick':
            import('../assets/scss/buick.scss');
            break;
        case 'cadillac':
            import('../assets/scss/cadillac.scss');
            break;
        case 'chevy':
            import('../assets/scss/chevy.scss');
            break;
        case 'gmc':
            import('../assets/scss/gmc.scss');
            break;
        default:
            import('../assets/scss/generalStyles.scss');
    }
};

export default CSSRenderer;